// src/components/editor/PreviewArea.jsx
import React from 'react';
import { Eye } from 'lucide-react';
import { renderPreviewComponent } from '../../utils/renderPreviewComponent';

export default function PreviewArea({ components, onImageClick }) {
  if (components.length === 0) return null;

  return (
    <div className="mt-8 bg-white rounded-xl shadow-lg p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <Eye className="w-5 h-5 mr-2 text-green-600" />
        页面预览
      </h2>
      <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl p-8 min-h-96 flex items-center justify-center">
        <div className="max-w-md w-full space-y-6">
          {components.map((component, index) => (
            <div key={index} className="text-center">
              {renderPreviewComponent(component, onImageClick)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}